if (import.meta.hot) {
  import.meta.hot.accept();
}

document.addEventListener('DOMContentLoaded', async () => {
  const codeBlocks = document.querySelectorAll('pre code');
  if (!codeBlocks.length) return;

  // Detect languages used in code blocks
  const languages = new Set();
  codeBlocks.forEach((el) => {
    const match = [...el.classList].find(c =>
      c.startsWith('language-') || c.startsWith('lang-')
    );
    if (match) {
      const lang = match.replace(/^language-|^lang-/, '').toLowerCase();
      languages.add(lang);
    }
  });

  // Always include plaintext fallback
  languages.add('plaintext');

  // Load Highlight.js core + theme
  const { default: hljs } = await import('highlight.js/lib/core');
  await Promise.all([
    import('highlight.js/styles/a11y-light.css'),
  ]);

  // Define a language import map for all languages we have defined in the RTE Config
  // @see EXT:twtde-base/Configuration/RTE/RteDefaultPreset.yaml
  const languageModules = {
    plaintext: () => import('highlight.js/lib/languages/plaintext'),
    php: () => import('highlight.js/lib/languages/php'),
    sql: () => import('highlight.js/lib/languages/sql'),
    yaml: () => import('highlight.js/lib/languages/yaml'),
    json: () => import('highlight.js/lib/languages/json'),
    css: () => import('highlight.js/lib/languages/css'),
    scss: () => import('highlight.js/lib/languages/scss'),
    javascript: () => import('highlight.js/lib/languages/javascript'),
    typescript: () => import('highlight.js/lib/languages/typescript'),
    markdown: () => import('highlight.js/lib/languages/markdown'),
    xml: () => import('highlight.js/lib/languages/xml'),
    html: () => import('highlight.js/lib/languages/xml'),
    nginx: () => import('highlight.js/lib/languages/nginx'),
    apache: () => import('highlight.js/lib/languages/apache'),
    bash: () => import('highlight.js/lib/languages/bash'),
    shell: () => import('highlight.js/lib/languages/shell'),
    c: () => import('highlight.js/lib/languages/c'),
    cpp: () => import('highlight.js/lib/languages/cpp'),
    csharp: () => import('highlight.js/lib/languages/csharp'),
    go: () => import('highlight.js/lib/languages/go'),
    java: () => import('highlight.js/lib/languages/java'),
    python: () => import('highlight.js/lib/languages/python'),
    rust: () => import('highlight.js/lib/languages/rust'),
    twig: () => import('highlight.js/lib/languages/twig'),
  };

  // Only load languages actually detected
  await Promise.all(
    Array.from(languages).map(async (lang) => {
      const loader = languageModules[lang];
      if (loader) {
        const { default: module } = await loader();
        hljs.registerLanguage(lang, module);
      } else {
        console.warn(`[Highlight.js] Could not find the language '${lang}', did you forget to load/include a language module?.`);
      }
    })
  );

  // Highlight all blocks
  codeBlocks.forEach((el) => hljs.highlightElement(el));
});
